import FuturesProps from "@/components/PortableText/Odds/FuturesProps";
import TeamProps from "@/components/PortableText/Odds/TeamProps";
import { AuthorBet } from "@/graphql/gql/graphql";
import useDynamicOdds from "@/utils/hooks/useDynamicOdds";
import styles from "./featuredBet.module.scss";

interface BetDisplay {
  bet: AuthorBet["market"];
  name: string;
  sportName?: string;
  eventName?: string;
  showTitle?: boolean;
}

export default function BetDisplay({
  bet,
  name,
  sportName,
  eventName,
  showTitle = true,
}: BetDisplay) {
  const { odds, title } = useDynamicOdds(bet ?? undefined, eventName);

  return (
    <div>
      {showTitle ? (
        <p className={styles.betLabel}>{`${name}'s pick: ${title}`}</p>
      ) : null}
      {bet?.type === "CORE MARKET" ? (
        <TeamProps
          {...odds}
          isFeaturedBet={true}
          authorName={name}
          sportName={sportName}
        />
      ) : (
        <FuturesProps
          {...odds}
          isFeaturedBet={true}
          authorName={name}
          sportName={sportName}
        />
      )}
    </div>
  );
}
